import { render } from "./ValidationFirstArchitecture.vue?vue&type=template&id=5763bb0f"
import script from "./ValidationFirstArchitecture.vue?vue&type=script&lang=js"
export * from "./ValidationFirstArchitecture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__